import { DataType } from '@globaleris/ui.library'
import { InputFieldConfig } from '../../../components/shared/genericCustomFormDialog/genericCustomFormDialog.model'

export const invoiceDetailsInputFields: InputFieldConfig[] = [
  {
    name: 'subjectSource',
    label: 'tasks:editTask.genericCustomFormDialog.inputs.Factura.subjectSource',
    type: DataType.TEXT,
    readOnly: true
  },
  {
    name: 'subject',
    label: 'tasks:editTask.genericCustomFormDialog.inputs.Factura.subject',
    type: DataType.TEXT,
    readOnly: true
  },
  {
    name: 'cups',
    label: 'tasks:editTask.genericCustomFormDialog.inputs.Factura.cups',
    type: DataType.TEXT,
    readOnly: true
  },
  {
    name: 'contractCode',
    label: 'tasks:editTask.genericCustomFormDialog.inputs.Factura.contractCode',
    type: DataType.TEXT,
    readOnly: true
  }
]
